import { useIonRouter } from "@ionic/react";
import { useCallback, useEffect } from "react";
import { useFormsStore } from "../../../../../Common/store/common";
import { getErrorMsg } from "../../../../../Common/utils/common";
import { bugNotif } from "../../../../api/bugsnag";
import LoginOTPInterfaceStore from "../../interface/LoginOTPInterface";

const useVerifySuccessSync = () => {
  const router = useIonRouter();

  const handleVerifySuccess = useCallback(async () => {
    try {
      const { setFormLoading } = useFormsStore.getState();
      setFormLoading(true);
      router.goBack();
    } catch (errorUnknown) {
      const { setFormLoading } = useFormsStore.getState();
      setFormLoading(false);
      const { rawErrorMsg } = getErrorMsg(errorUnknown);
      bugNotif("useVerifySuccessSync", rawErrorMsg);
    }
  }, [router]);

  useEffect(() => {
    const { setHandleVerifySuccess } = LoginOTPInterfaceStore.getState();
    setHandleVerifySuccess(handleVerifySuccess);
  }, [handleVerifySuccess]);
};

export default useVerifySuccessSync;
